<app-header></app-header>
<main class="bg-app-primary-light">
  <ng-content></ng-content>
  <router-outlet *ngIf="!this.isContentHasRouter"></router-outlet>
</main>
<app-footer></app-footer>
